var React = require('react');

function IconCamera (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"M26.6,2.9h-6l-0.7-2.2C19.7,0.3,19.3,0,18.9,0h-7.7c-0.4,0-0.8,0.3-0.9,0.7L9.5,2.9h-6C1.5,2.9,0,4.5,0,6.3V21\n\tc0,1.9,1.5,3.4,3.4,3.4h23.2c1.9,0,3.4-1.5,3.4-3.4V6.3C30,4.5,28.5,2.9,26.6,2.9z M5.4,8.6H4.4C3.5,8.6,2.9,8,2.9,7.2\n\tc0-0.8,0.7-1.5,1.5-1.5h1.1c0.8,0,1.5,0.7,1.5,1.5C6.9,8,6.3,8.6,5.4,8.6z M15,18.7c-2.8,0-5-2.2-5-5s2.2-5,5-5c2.8,0,5,2.2,5,5\n\tS17.8,18.7,15,18.7z"}));
}

IconCamera.defaultProps = {"viewBox":"0 0 30 24.4"};

module.exports = IconCamera;

IconCamera.default = IconCamera;



//////////////////
// WEBPACK FOOTER
// ./src/static/svgs/icon-camera.svg
// module id = 303
// module chunks = 35783957827783 159909797682334